import Vue from 'vue';
import querystring from 'querystring';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import * as Articulos from '@/__env/lib/Articulos';
import { Articulo } from '@/__env/lib/Articulos';


export class ControladorSeccion
{

    public readonly Buscador: Buscador = new Buscador();
    public Seleccionados: Articulo[] = [];

    Iniciar()
    {
        this.Buscador.Iniciar();
    }


    Abrir( x: Articulo )
    {
        if ( x && x.Existe )
        {
            router.push( '/articulo/' + x.Id.eliminar( '/' ) );
        }
    }

    AbrirEnOtraPestaña( x: Articulo )
    {
        if ( x && x.Existe )
        {
            window.open( '/#/articulo/' + x.Id.eliminar( '/' ) );
        }
    }

    public Vista: Vista = new Vista();
    private _onSeleccionados = new SignalDispatcher();
    public get onSeleccionados() { return this._onSeleccionados.asEvent(); }

    public RecargarEstadistica()
    {
        this._onRecargarEstadistica.dispatch();
    }
    private _onRecargarEstadistica = new SignalDispatcher();
    public get onRecargarEstadistica() { return this._onRecargarEstadistica.asEvent(); }
}

export class Vista
{
    public Filtros: FiltrosBase = new FiltrosBase();

    protected modo: string = 'resumen';
    get Modo(): string { return this.modo; }
    set Modo( m: string ) { this.modo = m; this._onModo.dispatch(); }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }
}

type Estado = 'cargando' | 'vacio' | 'ok' | 'error';
export class Buscador
{

    public Items: Articulo[] = [];

    public Filtros: Filtros = new Filtros( this );
    Iniciar()
    {
        this.Filtros = new Filtros( this );
    }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    public Paginacion: Paginacion;

    public async Buscar( pagina: number = null )
    {
        if ( pagina )
            this.Filtros.Valores.Pagina = pagina;

        this.Items.clear();
        this.Estado = 'cargando';
        Utiles.setQuery( this.Filtros.get() );
        this._onActualizar.dispatch();


        await Wait( 100 );
        let ff = this.Filtros.Obtener();
        ff.details = 'titulo,sector,linea,marca,imagenes';
        let e = await Articulo.find( ff );
        if ( e.Error )
            this.Estado = 'error';
        else
        {
            this.Items = e.Items;
            this.Paginacion = e.Paginacion;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this._onActualizar.dispatch();
    }
}

export class Filtros
{
    constructor( b: Buscador )
    {
        this.Buscador = b;
    }

    public Buscador: Buscador;
    public Busqueda: string = '';

    public Valores: Record<string, any> = {
        Estado: 0,
        Tipo: 0,
        Limite: 1,
        Orden: 1,
        Indice: 1,
        Pagina: 1,
        Tag: 0,
        Titulo: null,
        Sector: null,
        Linea: null,
        Marca: null,
    };


    public get Estados() { return Articulos.Estados.Filter; }
    public get Tipos() { return Articulos.Tipos.Filter; }
    public get Limites() { return [{ Nombre: '5', Id: 5 }, { Nombre: '10', Id: 10 }, { Nombre: '20', Id: 20 }, { Nombre: '50', Id: 50 }]; }
    public get Ordenes() { return [{ Nombre: 'Descendente', Id: 'DESC' }, { Nombre: 'Ascendente', Id: 'ASC' }]; }
    public get Indices() { return [{ Nombre: 'Id', Id: 'id' }, { Nombre: 'Alfabetico', Id: 'descripcion' }]; }
    public get Tags()
    {
        return [
            { Nombre: 'Todos', Id: '' },
            { Nombre: 'Error en codigo', Id: 'error_en_codigo', Valor: 'error_en_codigo' },
            { Nombre: 'Disponibles para reactivar', Id: 'disponible_para_reactivar', Valor: 'disponible_para_reactivar' },
            { Nombre: 'Potencialmente en falta', Id: 'en_falta', Valor: 'en_falta' },
            { Nombre: 'Pausadas por faltante', Id: 'pausado_por_faltante', Valor: 'pausado_por_faltante' },
            { Nombre: 'Pausadas por stock cero', Id: 'pausado_por_stock_cero', Valor: 'pausado_por_stock_cero' },
        ];
    }

    public get Activos(): { Nombre: string, Eliminar: any; }[]
    {
        let a: { Nombre: string, Eliminar: any; }[] = [];

        if ( this.Busqueda )
        {
            a.push( { Nombre: `Resultados para: ${this.Busqueda}`, Eliminar: () => { this.Busqueda = ''; this.Buscador.Buscar(); } } );
        }
        else
        {

            if ( this.Valores.Estado > 0 )
            {
                a.push( { Nombre: this.Estados[this.Valores.Estado].Nombre, Eliminar: () => { this.Valores.Estado = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Tag > 0 )
            {
                a.push( { Nombre: this.Tags[this.Valores.Tag].Nombre, Eliminar: () => { this.Valores.Tag = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Tipo > 0 )
            {
                a.push( { Nombre: this.Tipos[this.Valores.Tipo].Nombre, Eliminar: () => { this.Valores.Tipo = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Titulo ) a.push( { Nombre: 'Categoría: ' + this.Valores.Titulo.Descripcion, Eliminar: () => { this.Valores.Titulo = null; this.Buscador.Buscar(); } } );
            if ( this.Valores.Sector ) a.push( { Nombre: 'Sector: ' + this.Valores.Sector.Descripcion, Eliminar: () => { this.Valores.Sector = null; this.Buscador.Buscar(); } } );
            if ( this.Valores.Linea ) a.push( { Nombre: 'Linea: ' + this.Valores.Linea.Descripcion, Eliminar: () => { this.Valores.Linea = null; this.Buscador.Buscar(); } } );
            if ( this.Valores.Marca ) a.push( { Nombre: 'Marca: ' + this.Valores.Marca.Descripcion, Eliminar: () => { this.Valores.Marca = null; this.Buscador.Buscar(); } } );
        }

        return a;
    }

    public Obtener(): any
    {
        let filtro: any = {};
        filtro.busqueda = 'S';
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }
        else
        {

            if ( this.Valores.Estado > 0 )
            {
                filtro.estado = this.Estados[this.Valores.Estado].Valor.map( x => x.Id ).join( ',' );
            }

            if ( this.Valores.Tag > 0 )
            {
                filtro.tags = this.Tags[this.Valores.Tag].Id;
            }



            if ( this.Valores.Tipo > 0 )
            {
                filtro.tipo_articulo = this.Tipos[this.Valores.Tipo].Valor.map( x => x.Id ).join( ',' );
            }


            if ( this.Valores.Titulo ) filtro.titulo = this.Valores.Titulo.Id;
            if ( this.Valores.Sector ) filtro.sector = this.Valores.Sector.Id;
            if ( this.Valores.Linea ) filtro.linea = this.Valores.Linea.Id;
            if ( this.Valores.Marca ) filtro.marca = this.Valores.Marca.Id;



        }

        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }

        return filtro;
    }

    public set( filtro: any )
    {

        if ( filtro.q )
        {
            this.Busqueda = String( filtro.q );
        }

        if ( filtro.estado )
        {
            this.Valores.Estado = 0;
            let idx = this.Estados.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.estado );
            if ( idx > 0 ) this.Valores.Estado = idx;
        }

        if ( filtro.estado )
        {
            this.Valores.Tag = 0;
            let idx = this.Tags.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.tag );
            if ( idx > 0 ) this.Valores.Tag = idx;
        }

        if ( filtro.tipo_articulo )
        {
            this.Valores.Tipo = 0;
            let idx = this.Tipos.findIndex( x => x.Nombre.toLowerCase().eliminar( ' ' ) == filtro.tipo );
            if ( idx > 0 ) this.Valores.Tipo = idx;
        }

        if ( filtro.limit )
        {
            this.Valores.Limite = 1;
            let idx = this.Limites.findIndex( x => x.Id == filtro.limit );
            if ( idx > 0 ) this.Valores.Limite = idx;
        }

        if ( filtro.sort )
        {
            this.Valores.Orden = 0;
            let idx = this.Ordenes.findIndex( x => x.Id == filtro.sort );
            if ( idx > 0 ) this.Valores.Orden = idx;
        }

        if ( filtro.order )
        {
            this.Valores.Indice = 0;
            let idx = this.Indices.findIndex( x => x.Id == filtro.order );
            if ( idx > 0 ) this.Valores.Indice = idx;
        }

        if ( filtro.page > 0 )
        {
            this.Valores.Pagina = filtro.page;
        }

    }

    public get(): string
    {
        let filtro: any = {};
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }

        if ( this.Valores.Estado > 0 )
        {
            filtro.estado = this.Estados[this.Valores.Estado].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Tag > 0 )
        {
            filtro.tag = this.Tags[this.Valores.Tag].Nombre.eliminar( ' ' ).toLowerCase();
        }


        if ( this.Valores.Tipo > 0 )
        {
            filtro.tipo_articulo = this.Tipos[this.Valores.Tipo].Nombre.eliminar( ' ' ).toLowerCase();


        }

        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }


        return querystring.encode( filtro );
    }
}

const Controlador = new ControladorSeccion();
export { Controlador };

